import { subscribe } from '../appEventBus';
import { updateDatadogUser } from '../../analytics/datadogUtils';
import { appsFlyerSetUserId } from '../../analytics/appsflyer/client';
import { snowplowSetUser } from '../../analytics/snowplow/client';

subscribe('AUTH_STATE_CHANGED', ({ user_id }) => {
  snowplowSetUser(user_id);
  updateDatadogUser(user_id ? { id: user_id } : null);
  appsFlyerSetUserId(user_id || '');
});
